import React from 'react';
import {WithPermission} from 'admin-on-rest';
import {resolveAccess} from '../shared/authFunctions';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardHeader, CardText, CardActions} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Avatar from 'material-ui/Avatar';
import ListIcon from 'material-ui/svg-icons/action/view-list';
import AddIcon from 'material-ui/svg-icons/content/add';
import LoyaltyIcon from 'material-ui/svg-icons/action/card-giftcard';
import {fuseLoyaltyRankIcon as LoyaltyRankIcon} from './rank';
import {fuseLoyaltyIncentiveTierIcon as LoyaltyIncentiveTierIcon} from './incentiveTier';
import {fuseVipCardConfigIcon as ConfigIcon} from './vipCardConfig';
import {fuseLoyaltyAccountIcon as LoyaltyAccountIcon} from './account';
import {fuseLoyaltyAccountLockIcon as LoyaltyAccountLockIcon} from './log';
import {dashStyles} from '../shared/styles-dashboard';

export default () => (
    <div>

        {/* Loyalty Header (full access) */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['loyalty_all'])}>
            <Card style={{...dashStyles.marginBottom}}>
                <LoyaltyIcon style={dashStyles.dashIcon}/>
                <ViewTitle title="Loyalty Program"/>
                <CardText>
                    <p>
                        Create and Manage Loyalty Program cards and accounts, Loyalty Ranks, Incentive Tiers, and fraud
                        lists.</p>
                    <hr style={dashStyles.break}/>
                </CardText>
            </Card>
        </WithPermission>

        {/* Loyalty Header (Loyalty CSR) */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['loyalty_csr'])}>
            <Card style={{...dashStyles.marginBottom}}>
                <LoyaltyIcon style={dashStyles.dashIcon}/>
                <ViewTitle title="Loyalty Program"/>
                <CardText>
                    <p>
                        Create and Manage Loyalty Program accounts.</p>
                    <hr style={dashStyles.break}/>
                </CardText>
            </Card>
        </WithPermission>

        {/* Loyalty Header (Loyalty CSR) */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['loyalty_vo'])}>
            <Card style={{...dashStyles.marginBottom}}>
                <LoyaltyIcon style={dashStyles.dashIcon}/>
                <ViewTitle title="Loyalty Program"/>
                <CardText>
                    <p>
                        View Loyalty Program accounts.</p>
                    <hr style={dashStyles.break}/>
                </CardText>
            </Card>
        </WithPermission>

        <WithPermission
            resolve={(props) => resolveAccess(props.permissions, ['loyalty_all', 'loyalty_csr', 'loyalty_vo'])}>

            {/* Loyalty Ranks */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Loyalty Ranks"
                    subtitle="Levels for rewarding purchases by Loyalty Account Customers. Click to read more."
                    avatar={<Avatar icon={<LoyaltyRankIcon/>} style={dashStyles.avatar}/>}
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <p>
                        Loyalty Ranks set levels for Loyalty Account Customers to reach, offering reward points and
                        earning ratios that can increase with purchases.
                    </p>
                    <p>
                        Ranks work with Incentive Tiers to provide extra points for customers. Ranks and Tiers must
                        exist
                        before Loyalty Accounts may be created.
                    </p>
                    <hr style={dashStyles.break}/>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="List Ranks" href="#/LoyaltyRanks"/>
                    <WithPermission resolve={(props) => resolveAccess(props.permissions, ['loyalty_all'])}>
                        <FlatButton icon={<AddIcon/>} label="Add a Loyalty Rank" href="#/LoyaltyRanks/create"/>
                    </WithPermission>
                </CardActions>
            </Card>

            {/* Loyalty Incentive Tiers */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Incentive Tiers"
                    subtitle="Settings for increasing Reward Points awarded to Loyalty Account Customers. Click to read more."
                    avatar={<Avatar icon={<LoyaltyIncentiveTierIcon/>} style={dashStyles.avatar}/>}
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <p>
                        Incentive Tiers set minimum dollar amounts that increase Reward Point earnings for Loyalty
                        Account
                        Customers. Each amount sets a multiplier for Reward Points.
                    </p>
                    <p>
                        Incentive Tiers work with Ranks to provide extra points for customers. Ranks and Tiers must
                        exist
                        before Loyalty Accounts may be created.
                    </p>
                    <hr style={dashStyles.break}/>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="List Incentive Tiers" href="#/LoyaltyIncentiveTiers"/>
                    <WithPermission resolve={(props) => resolveAccess(props.permissions, ['loyalty_all'])}>
                        <FlatButton icon={<AddIcon/>} label="Add an Incentive Tier"
                                    href="#/LoyaltyIncentiveTiers/create"/>
                    </WithPermission>
                </CardActions>
            </Card>

            {/* VIP Card Configuration */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}}>
                <WithPermission resolve={(props) => resolveAccess(props.permissions, ['loyalty_all', 'loyalty_csr'])}>
                    <CardHeader
                        title="VIP Card Configuration"
                        subtitle="Create VIP account prefixes and number ranges. Click to read more."
                        avatar={<Avatar icon={<ConfigIcon/>} style={dashStyles.avatar}/>}
                        actAsExpander={true}
                        showExpandableButton={true}
                    />
                </WithPermission>
                <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['loyalty_vo'])}>
                    <CardHeader
                        title="VIP Card Configuration"
                        subtitle="View VIP account prefixes and number ranges. Click to read more."
                        avatar={<Avatar icon={<ConfigIcon/>} style={dashStyles.avatar}/>}
                        actAsExpander={true}
                        showExpandableButton={true}
                    />
                </WithPermission>
                <CardText expandable={true}>
                    <p>
                        A <strong>VIP Card</strong> represents a Loyalty Program account created either online or at a
                        store Location's register via the POS.
                    </p>
                    <p>
                        Loyalty Card Configurations consist of a seven-letter prefix and a range of six-digit numbers.
                        This becomes a set of available ID numbers for use as Loyalty accounts.
                    </p>
                    <hr style={dashStyles.break}/>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="List Configurations" href="#/VipCardConfigurations"/>
                    <WithPermission resolve={(props) => resolveAccess(props.permissions, ['loyalty_all'])}>
                        <FlatButton icon={<AddIcon/>} label="Add a Loyalty Card Configuration"
                                    href="#/VipCardConfigurations/create"/>
                    </WithPermission>
                </CardActions>
            </Card>

            {/* Loyalty Accounts */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}}>
                <WithPermission
                    resolve={(props) => resolveAccess(props.permissions, ['loyalty_all', 'loyalty_csr'])}>
                    <CardHeader
                        title="Loyalty Accounts"
                        subtitle="Create Loyalty Accounts. Click to read more."
                        avatar={<Avatar icon={<LoyaltyAccountIcon/>} style={dashStyles.avatar}/>}
                        actAsExpander={true}
                        showExpandableButton={true}
                    />
                </WithPermission>
                <WithPermission
                    resolve={(props) => resolveAccess(props.permissions, [], ['loyalty_vo'])}>
                    <CardHeader
                        title="Loyalty Accounts"
                        subtitle="View Loyalty Accounts. Click to read more."
                        avatar={<Avatar icon={<LoyaltyAccountIcon/>} style={dashStyles.avatar}/>}
                        actAsExpander={true}
                        showExpandableButton={true}
                    />
                </WithPermission>
                <CardText expandable={true}>
                    <p>
                        Loyalty Accounts allow customers to earn Reward Points and Ranks when purchasing from the POS
                        System. Each purchase accumulates points, and higher ranks offer more points per dollar spent.
                    </p>
                    <p>
                        A customer may have multiple Accounts, and may apply more than one account during a purchase.
                    </p>
                    <p>
                        Loyalty Ranks and Incentive Tiers must exist before Loyalty Accounts may be created. Create at
                        least one Rank and Tier before creating an Account via the Admin or the POS System.
                    </p>
                    <hr style={dashStyles.break}/>
                </CardText>
                <CardActions>
                    <WithPermission
                        resolve={(props) => resolveAccess(props.permissions, ['loyalty_all', 'loyalty_csr'])}>
                        <FlatButton icon={<ListIcon/>} label="Find Loyalty Accounts" href="#/LoyaltyAccounts"/>
                        <FlatButton icon={<AddIcon/>} label="Add a Loyalty Account" href="#/LoyaltyAccounts/create"/>
                    </WithPermission>
                    <WithPermission
                        resolve={(props) => resolveAccess(props.permissions, [], ['loyalty_vo'])}>
                        <FlatButton icon={<ListIcon/>} label="Find Loyalty Accounts" href="#/LoyaltyAccounts"/>
                    </WithPermission>
                </CardActions>
            </Card>

            {/* Fraud and Temp Logs */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Locked Accounts and Fraud"
                    subtitle="Manage Customers and transactions marked as fraudulent. Click to read more."
                    avatar={<Avatar icon={<LoyaltyAccountLockIcon/>} style={dashStyles.avatar}/>}
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <p>
                        When a Customer uses fraudulent data during a purchase, a Fraud Lock may be placed on the
                        Customer's Loyalty Account. If purchases require review, such as a series of failed transaction
                        attempts, the Account may also be Temp-Locked until it is reviewed.
                    </p>
                    <hr style={dashStyles.break}/>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="Review Account Lock Logs" href="#/LoyaltyAccountLogs"/>
                </CardActions>
            </Card>
        </WithPermission>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/Loyalty/dashboard.js